export const timeZones = {
  "Africa/Abidjan": "0:00",
  "Africa/Accra": "0:00",
  "Africa/Addis_Ababa": "+3:00",
  "Africa/Algiers": "+1:00",
  "Africa/Asmara": "+3:00",
  "Africa/Asmera": "+3:00",
  "Africa/Bamako": "0:00",
  "Africa/Bangui": "+1:00",
  "Africa/Banjul": "0:00",
  "Africa/Bissau": "0:00",
  "Africa/Blantyre": "+2:00",
  "Africa/Brazzaville": "+1:00",
  "Africa/Bujumbura": "+2:00",
  "Africa/Cairo": "+2:00",
  "Africa/Casablanca": "0:00",
  "Africa/Ceuta": "+1:00",
  "Africa/Conakry": "0:00",
  "Africa/Dakar": "0:00",
  "Africa/Dar_es_Salaam": "+3:00",
  "Africa/Djibouti": "+3:00",
  "Africa/Douala": "+1:00",
  "Africa/El_Aaiun": "0:00",
  "Africa/Freetown": "0:00",
  "Africa/Gaborone": "+2:00",
  "Africa/Harare": "+2:00",
  "Africa/Johannesburg": "+2:00",
  "Africa/Juba": "+3:00",
  "Africa/Kampala": "+3:00",
  "Africa/Khartoum": "+3:00",
  "Africa/Kigali": "+2:00",
  "Africa/Kinshasa": "+1:00",
  "Africa/Lagos": "+1:00",
  "Africa/Libreville": "+1:00",
  "Africa/Lome": "0:00",
  "Africa/Luanda": "+1:00",
  "Africa/Lubumbashi": "+2:00",
  "Africa/Lusaka": "+2:00",
  "Africa/Malabo": "+1:00",
  "Africa/Maputo": "+2:00",
  "Africa/Maseru": "+2:00",
  "Africa/Mbabane": "+2:00",
  "Africa/Mogadishu": "+3:00",
  "Africa/Monrovia": "0:00",
  "Africa/Nairobi": "+3:00",
  "Africa/Ndjamena": "+1:00",
  "Africa/Niamey": "+1:00",
  "Africa/Nouakchott": "0:00",
  "Africa/Ouagadougou": "0:00",
  "Africa/Porto-Novo": "+1:00",
  "Africa/Sao_Tome": "0:00",
  "Africa/Timbuktu": "0:00",
  "Africa/Tripoli": "+2:00",
  "Africa/Tunis": "+1:00",
  "Africa/Windhoek": "+1:00",
  "America/Adak": "-10:00",
  "America/Anchorage": "-9:00",
  "America/Anguilla": "-4:00",
  "America/Antigua": "-4:00",
  "America/Araguaina": "-3:00",
  "America/Argentina/Buenos_Aires": "-3:00",
  "America/Argentina/Catamarca": "-3:00",
  "America/Argentina/ComodRivadavia": "-3:00",
  "America/Argentina/Cordoba": "-3:00",
  "America/Argentina/Jujuy": "-3:00",
  "America/Argentina/La_Rioja": "-3:00",
  "America/Argentina/Mendoza": "-3:00",
  "America/Argentina/Rio_Gallegos": "-3:00",
  "America/Argentina/Salta": "-3:00",
  "America/Argentina/San_Juan": "-3:00",
  "America/Argentina/San_Luis": "-3:00",
  "America/Argentina/Tucuman": "-3:00",
  "America/Argentina/Ushuaia": "-3:00",
  "America/Aruba": "-4:00",
  "America/Asuncion": "-4:00",
  "America/Atikokan": "-5:00",
  "America/Atka": "-10:00",
  "America/Bahia": "-3:00",
  "America/Bahia_Banderas": "-6:00",
  "America/Barbados": "-4:00",
  "America/Belem": "-3:00",
  "America/Belize": "-6:00",
  "America/Blanc-Sablon": "-4:00",
  "America/Boa_Vista": "-4:00",
  "America/Bogota": "-5:00",
  "America/Boise": "-7:00",
  "America/Buenos_Aires": "-3:00",
  "America/Cambridge_Bay": "-7:00",
  "America/Campo_Grande": "-4:00",
  "America/Cancun": "-5:00",
  "America/Caracas": "-4:00",
  "America/Catamarca": "-3:00",
  "America/Cayenne": "-3:00",
  "America/Cayman": "-5:00",
  "America/Chicago": "-6:00",
  "America/Chihuahua": "-7:00",
  "America/Coral_Harbour": "-5:00",
  "America/Cordoba": "-3:00",
  "America/Costa_Rica": "-6:00",
  "America/Creston": "-7:00",
  "America/Cuiaba": "-4:00",
  "America/Curacao": "-4:00",
  "America/Danmarkshavn": "0:00",
  "America/Dawson": "-8:00",
  "America/Dawson_Creek": "-7:00",
  "America/Denver": "-7:00",
  "America/Detroit": "-5:00",
  "America/Dominica": "-4:00",
  "America/Edmonton": "-7:00",
  "America/Eirunepe": "-5:00",
  "America/El_Salvador": "-6:00",
  "America/Ensenada": "-8:00",
  "America/Fort_Nelson": "-7:00",
  "America/Fort_Wayne": "-5:00",
  "America/Fortaleza": "-3:00",
  "America/Glace_Bay": "-4:00",
  "America/Godthab": "-3:00",
  "America/Goose_Bay": "-4:00",
  "America/Grand_Turk": "-4:00",
  "America/Grenada": "-4:00",
  "America/Guadeloupe": "-4:00",
  "America/Guatemala": "-6:00",
  "America/Guayaquil": "-5:00",
  "America/Guyana": "-4:00",
  "America/Halifax": "-4:00",
  "America/Havana": "-5:00",
  "America/Hermosillo": "-7:00",
  "America/Indiana/Indianapolis": "-5:00",
  "America/Indiana/Knox": "-6:00",
  "America/Indiana/Marengo": "-5:00",
  "America/Indiana/Petersburg": "-5:00",
  "America/Indiana/Tell_City": "-6:00",
  "America/Indiana/Vevay": "-5:00",
  "America/Indiana/Vincennes": "-5:00",
  "America/Indiana/Winamac": "-5:00",
  "America/Indianapolis": "-5:00",
  "America/Inuvik": "-7:00",
  "America/Iqaluit": "-5:00",
  "America/Jamaica": "-5:00",
  "America/Jujuy": "-3:00",
  "America/Juneau": "-9:00",
  "America/Kentucky/Louisville": "-5:00",
  "America/Kentucky/Monticello": "-5:00",
  "America/Knox_IN": "-6:00",
  "America/Kralendijk": "-4:00",
  "America/La_Paz": "-4:00",
  "America/Lima": "-5:00",
  "America/Los_Angeles": "-8:00",
  "America/Louisville": "-5:00",
  "America/Lower_Princes": "-4:00",
  "America/Maceio": "-3:00",
  "America/Managua": "-6:00",
  "America/Manaus": "-4:00",
  "America/Marigot": "-4:00",
  "America/Martinique": "-4:00",
  "America/Matamoros": "-6:00",
  "America/Mazatlan": "-7:00",
  "America/Mendoza": "-3:00",
  "America/Menominee": "-6:00",
  "America/Merida": "-6:00",
  "America/Metlakatla": "-9:00",
  "America/Mexico_City": "-6:00",
  "America/Miquelon": "-3:00",
  "America/Moncton": "-4:00",
  "America/Monterrey": "-6:00",
  "America/Montevideo": "-3:00",
  "America/Montreal": "-5:00",
  "America/Montserrat": "-4:00",
  "America/Nassau": "-5:00",
  "America/New_York": "-5:00",
  "America/Nipigon": "-5:00",
  "America/Nome": "-9:00",
  "America/Noronha": "-2:00",
  "America/North_Dakota/Beulah": "-6:00",
  "America/North_Dakota/Center": "-6:00",
  "America/North_Dakota/New_Salem": "-6:00",
  "America/Ojinaga": "-7:00",
  "America/Panama": "-5:00",
  "America/Pangnirtung": "-5:00",
  "America/Paramaribo": "-3:00",
  "America/Phoenix": "-7:00",
  "America/Port-au-Prince": "-5:00",
  "America/Port_of_Spain": "-4:00",
  "America/Porto_Acre": "-5:00",
  "America/Porto_Velho": "-4:00",
  "America/Puerto_Rico": "-4:00",
  "America/Rainy_River": "-6:00",
  "America/Rankin_Inlet": "-6:00",
  "America/Recife": "-3:00",
  "America/Regina": "-6:00",
  "America/Resolute": "-6:00",
  "America/Rio_Branco": "-5:00",
  "America/Rosario": "-3:00",
  "America/Santa_Isabel": "-8:00",
  "America/Santarem": "-3:00",
  "America/Santiago": "-4:00",
  "America/Santo_Domingo": "-4:00",
  "America/Sao_Paulo": "-3:00",
  "America/Scoresbysund": "-1:00",
  "America/Shiprock": "-7:00",
  "America/Sitka": "-9:00",
  "America/St_Barthelemy": "-4:00",
  "America/St_Johns": "-3:30",
  "America/St_Kitts": "-4:00",
  "America/St_Lucia": "-4:00",
  "America/St_Thomas": "-4:00",
  "America/St_Vincent": "-4:00",
  "America/Swift_Current": "-6:00",
  "America/Tegucigalpa": "-6:00",
  "America/Thule": "-4:00",
  "America/Thunder_Bay": "-5:00",
  "America/Tijuana": "-8:00",
  "America/Toronto": "-5:00",
  "America/Tortola": "-4:00",
  "America/Vancouver": "-8:00",
  "America/Virgin": "-4:00",
  "America/Whitehorse": "-8:00",
  "America/Winnipeg": "-6:00",
  "America/Yakutat": "-9:00",
  "America/Yellowknife": "-7:00",
  "Antarctica/Casey": "+8:00",
  "Antarctica/Davis": "+7:00",
  "Antarctica/DumontDUrville": "+10:00",
  "Antarctica/Macquarie": "+11:00",
  "Antarctica/Mawson": "+5:00",
  "Antarctica/McMurdo": "+12:00",
  "Antarctica/Palmer": "-4:00",
  "Antarctica/Rothera": "-3:00",
  "Antarctica/South_Pole": "+12:00",
  "Antarctica/Syowa": "+3:00",
  "Antarctica/Troll": "0:00",
  "Antarctica/Vostok": "+6:00",
  "Arctic/Longyearbyen": "+1:00",
  "Asia/Aden": "+3:00",
  "Asia/Almaty": "+6:00",
  "Asia/Amman": "+2:00",
  "Asia/Anadyr": "+12:00",
  "Asia/Aqtau": "+5:00",
  "Asia/Aqtobe": "+5:00",
  "Asia/Ashgabat": "+5:00",
  "Asia/Ashkhabad": "+5:00",
  "Asia/Baghdad": "+3:00",
  "Asia/Bahrain": "+3:00",
  "Asia/Baku": "+4:00",
  "Asia/Bangkok": "+7:00",
  "Asia/Barnaul": "+7:00",
  "Asia/Beirut": "+2:00",
  "Asia/Bishkek": "+6:00",
  "Asia/Brunei": "+8:00",
  "Asia/Calcutta": "+5:30",
  "Asia/Chita": "+9:00",
  "Asia/Choibalsan": "+8:00",
  "Asia/Chongqing": "+8:00",
  "Asia/Chungking": "+8:00",
  "Asia/Colombo": "+5:30",
  "Asia/Dacca": "+6:00",
  "Asia/Damascus": "+2:00",
  "Asia/Dhaka": "+6:00",
  "Asia/Dili": "+9:00",
  "Asia/Dubai": "+4:00",
  "Asia/Dushanbe": "+5:00",
  "Asia/Gaza": "+2:00",
  "Asia/Harbin": "+8:00",
  "Asia/Hebron": "+2:00",
  "Asia/Ho_Chi_Minh": "+7:00",
  "Asia/Hong_Kong": "+8:00",
  "Asia/Hovd": "+7:00",
  "Asia/Irkutsk": "+8:00",
  "Asia/Istanbul": "+2:00",
  "Asia/Jakarta": "+7:00",
  "Asia/Jayapura": "+9:00",
  "Asia/Jerusalem": "+2:00",
  "Asia/Kabul": "+4:30",
  "Asia/Kamchatka": "+12:00",
  "Asia/Karachi": "+5:00",
  "Asia/Kashgar": "+6:00",
  "Asia/Kathmandu": "+5:45",
  "Asia/Katmandu": "+5:45",
  "Asia/Khandyga": "+9:00",
  "Asia/Kolkata": "+5:30",
  "Asia/Krasnoyarsk": "+7:00",
  "Asia/Kuala_Lumpur": "+8:00",
  "Asia/Kuching": "+8:00",
  "Asia/Kuwait": "+3:00",
  "Asia/Macao": "+8:00",
  "Asia/Macau": "+8:00",
  "Asia/Magadan": "+11:00",
  "Asia/Makassar": "+8:00",
  "Asia/Manila": "+8:00",
  "Asia/Muscat": "+4:00",
  "Asia/Nicosia": "+2:00",
  "Asia/Novokuznetsk": "+7:00",
  "Asia/Novosibirsk": "+6:00",
  "Asia/Omsk": "+6:00",
  "Asia/Oral": "+5:00",
  "Asia/Phnom_Penh": "+7:00",
  "Asia/Pontianak": "+7:00",
  "Asia/Pyongyang": "+8:30",
  "Asia/Qatar": "+3:00",
  "Asia/Qyzylorda": "+6:00",
  "Asia/Rangoon": "+6:30",
  "Asia/Riyadh": "+3:00",
  "Asia/Saigon": "+7:00",
  "Asia/Sakhalin": "+11:00",
  "Asia/Samarkand": "+5:00",
  "Asia/Seoul": "+9:00",
  "Asia/Shanghai": "+8:00",
  "Asia/Singapore": "+8:00",
  "Asia/Srednekolymsk": "+11:00",
  "Asia/Taipei": "+8:00",
  "Asia/Tashkent": "+5:00",
  "Asia/Tbilisi": "+4:00",
  "Asia/Tehran": "+3:30",
  "Asia/Tel_Aviv": "+2:00",
  "Asia/Thimbu": "+6:00",
  "Asia/Thimphu": "+6:00",
  "Asia/Tokyo": "+9:00",
  "Asia/Tomsk": "+7:00",
  "Asia/Ujung_Pandang": "+8:00",
  "Asia/Ulaanbaatar": "+8:00",
  "Asia/Ulan_Bator": "+8:00",
  "Asia/Urumqi": "+6:00",
  "Asia/Ust-Nera": "+10:00",
  "Asia/Vientiane": "+7:00",
  "Asia/Vladivostok": "+10:00",
  "Asia/Yakutsk": "+9:00",
  "Asia/Yekaterinburg": "+5:00",
  "Asia/Yerevan": "+4:00",
  "Atlantic/Azores": "-1:00",
  "Atlantic/Bermuda": "-4:00",
  "Atlantic/Canary": "0:00",
  "Atlantic/Cape_Verde": "-1:00",
  "Atlantic/Faeroe": "0:00",
  "Atlantic/Faroe": "0:00",
  "Atlantic/Jan_Mayen": "+1:00",
  "Atlantic/Madeira": "0:00",
  "Atlantic/Reykjavik": "0:00",
  "Atlantic/South_Georgia": "-2:00",
  "Atlantic/St_Helena": "0:00",
  "Atlantic/Stanley": "-3:00",
  "Australia/ACT": "+10:00",
  "Australia/Adelaide": "+9:30",
  "Australia/Brisbane": "+10:00",
  "Australia/Broken_Hill": "+9:30",
  "Australia/Canberra": "+10:00",
  "Australia/Currie": "+10:00",
  "Australia/Darwin": "+9:30",
  "Australia/Eucla": "+8:45",
  "Australia/Hobart": "+10:00",
  "Australia/LHI": "+10:30",
  "Australia/Lindeman": "+10:00",
  "Australia/Lord_Howe": "+10:30",
  "Australia/Melbourne": "+10:00",
  "Australia/NSW": "+10:00",
  "Australia/North": "+9:30",
  "Australia/Perth": "+8:00",
  "Australia/Queensland": "+10:00",
  "Australia/South": "+9:30",
  "Australia/Sydney": "+10:00",
  "Australia/Tasmania": "+10:00",
  "Australia/Victoria": "+10:00",
  "Australia/West": "+8:00",
  "Australia/Yancowinna": "+9:30",
  "Brazil/Acre": "-5:00",
  "Brazil/DeNoronha": "-2:00",
  "Brazil/East": "-3:00",
  "Brazil/West": "-4:00",
  "CET": "+1:00",
  "CST6CDT": "-6:00",
  "Canada/Atlantic": "-4:00",
  "Canada/Central": "-6:00",
  "Canada/East-Saskatchewan": "-6:00",
  "Canada/Eastern": "-5:00",
  "Canada/Mountain": "-7:00",
  "Canada/Newfoundland": "-3:30",
  "Canada/Pacific": "-8:00",
  "Canada/Saskatchewan": "-6:00",
  "Canada/Yukon": "-8:00",
  "Chile/Continental": "-4:00",
  "Chile/EasterIsland": "-6:00",
  "Cuba": "-5:00",
  "EET": "+2:00",
  "EST5EDT": "-5:00",
  "Egypt": "+2:00",
  "Eire": "0:00",
  "Etc/GMT": "0:00",
  "Etc/GMT+0": "0:00",
  "Etc/GMT+1": "-1:00",
  "Etc/GMT+10": "-10:00",
  "Etc/GMT+11": "-11:00",
  "Etc/GMT+12": "-12:00",
  "Etc/GMT+2": "-2:00",
  "Etc/GMT+3": "-3:00",
  "Etc/GMT+4": "-4:00",
  "Etc/GMT+5": "-5:00",
  "Etc/GMT+6": "-6:00",
  "Etc/GMT+7": "-7:00",
  "Etc/GMT+8": "-8:00",
  "Etc/GMT+9": "-9:00",
  "Etc/GMT-0": "0:00",
  "Etc/GMT-1": "+1:00",
  "Etc/GMT-10": "+10:00",
  "Etc/GMT-11": "+11:00",
  "Etc/GMT-12": "+12:00",
  "Etc/GMT-13": "+13:00",
  "Etc/GMT-14": "+14:00",
  "Etc/GMT-2": "+2:00",
  "Etc/GMT-3": "+3:00",
  "Etc/GMT-4": "+4:00",
  "Etc/GMT-5": "+5:00",
  "Etc/GMT-6": "+6:00",
  "Etc/GMT-7": "+7:00",
  "Etc/GMT-8": "+8:00",
  "Etc/GMT-9": "+9:00",
  "Etc/GMT0": "0:00",
  "Etc/Greenwich": "0:00",
  "Etc/UCT": "0:00",
  "Etc/UTC": "0:00",
  "Etc/Universal": "0:00",
  "Etc/Zulu": "0:00",
  "Europe/Amsterdam": "+1:00",
  "Europe/Andorra": "+1:00",
  "Europe/Astrakhan": "+4:00",
  "Europe/Athens": "+2:00",
  "Europe/Belfast": "0:00",
  "Europe/Belgrade": "+1:00",
  "Europe/Berlin": "+1:00",
  "Europe/Bratislava": "+1:00",
  "Europe/Brussels": "+1:00",
  "Europe/Bucharest": "+2:00",
  "Europe/Budapest": "+1:00",
  "Europe/Busingen": "+1:00",
  "Europe/Chisinau": "+2:00",
  "Europe/Copenhagen": "+1:00",
  "Europe/Dublin": "0:00",
  "Europe/Gibraltar": "+1:00",
  "Europe/Guernsey": "0:00",
  "Europe/Helsinki": "+2:00",
  "Europe/Isle_of_Man": "0:00",
  "Europe/Istanbul": "+2:00",
  "Europe/Jersey": "0:00",
  "Europe/Kaliningrad": "+2:00",
  "Europe/Kiev": "+2:00",
  "Europe/Kirov": "+3:00",
  "Europe/Lisbon": "0:00",
  "Europe/Ljubljana": "+1:00",
  "Europe/London": "0:00",
  "Europe/Luxembourg": "+1:00",
  "Europe/Madrid": "+1:00",
  "Europe/Malta": "+1:00",
  "Europe/Mariehamn": "+2:00",
  "Europe/Minsk": "+3:00",
  "Europe/Monaco": "+1:00",
  "Europe/Moscow": "+3:00",
  "Europe/Nicosia": "+2:00",
  "Europe/Oslo": "+1:00",
  "Europe/Paris": "+1:00",
  "Europe/Podgorica": "+1:00",
  "Europe/Prague": "+1:00",
  "Europe/Riga": "+2:00",
  "Europe/Rome": "+1:00",
  "Europe/Samara": "+4:00",
  "Europe/San_Marino": "+1:00",
  "Europe/Sarajevo": "+1:00",
  "Europe/Simferopol": "+3:00",
  "Europe/Skopje": "+1:00",
  "Europe/Sofia": "+2:00",
  "Europe/Stockholm": "+1:00",
  "Europe/Tallinn": "+2:00",
  "Europe/Tirane": "+1:00",
  "Europe/Tiraspol": "+2:00",
  "Europe/Ulyanovsk": "+4:00",
  "Europe/Uzhgorod": "+2:00",
  "Europe/Vaduz": "+1:00",
  "Europe/Vatican": "+1:00",
  "Europe/Vienna": "+1:00",
  "Europe/Vilnius": "+2:00",
  "Europe/Volgograd": "+3:00",
  "Europe/Warsaw": "+1:00",
  "Europe/Zagreb": "+1:00",
  "Europe/Zaporozhye": "+2:00",
  "Europe/Zurich": "+1:00",
  "GB": "0:00",
  "GB-Eire": "0:00",
  "GMT": "0:00",
  "GMT0": "0:00",
  "Greenwich": "0:00",
  "Hongkong": "+8:00",
  "Iceland": "0:00",
  "Indian/Antananarivo": "+3:00",
  "Indian/Chagos": "+6:00",
  "Indian/Christmas": "+7:00",
  "Indian/Cocos": "+6:30",
  "Indian/Comoro": "+3:00",
  "Indian/Kerguelen": "+5:00",
  "Indian/Mahe": "+4:00",
  "Indian/Maldives": "+5:00",
  "Indian/Mauritius": "+4:00",
  "Indian/Mayotte": "+3:00",
  "Indian/Reunion": "+4:00",
  "Iran": "+3:30",
  "Israel": "+2:00",
  "Jamaica": "-5:00",
  "Japan": "+9:00",
  "Kwajalein": "+12:00",
  "Libya": "+2:00",
  "MET": "+1:00",
  "MST7MDT": "-7:00",
  "Mexico/BajaNorte": "-8:00",
  "Mexico/BajaSur": "-7:00",
  "Mexico/General": "-6:00",
  "NZ": "+12:00",
  "NZ-CHAT": "+12:45",
  "Navajo": "-7:00",
  "PRC": "+8:00",
  "PST8PDT": "-8:00",
  "Pacific/Apia": "+13:00",
  "Pacific/Auckland": "+12:00",
  "Pacific/Bougainville": "+11:00",
  "Pacific/Chatham": "+12:45",
  "Pacific/Chuuk": "+10:00",
  "Pacific/Easter": "-6:00",
  "Pacific/Efate": "+11:00",
  "Pacific/Enderbury": "+13:00",
  "Pacific/Fakaofo": "+13:00",
  "Pacific/Fiji": "+12:00",
  "Pacific/Funafuti": "+12:00",
  "Pacific/Galapagos": "-6:00",
  "Pacific/Gambier": "-9:00",
  "Pacific/Guadalcanal": "+11:00",
  "Pacific/Guam": "+10:00",
  "Pacific/Honolulu": "-10:00",
  "Pacific/Johnston": "-10:00",
  "Pacific/Kiritimati": "+14:00",
  "Pacific/Kosrae": "+11:00",
  "Pacific/Kwajalein": "+12:00",
  "Pacific/Majuro": "+12:00",
  "Pacific/Marquesas": "-9:30",
  "Pacific/Midway": "-11:00",
  "Pacific/Nauru": "+12:00",
  "Pacific/Niue": "-11:00",
  "Pacific/Norfolk": "+11:00",
  "Pacific/Noumea": "+11:00",
  "Pacific/Pago_Pago": "-11:00",
  "Pacific/Palau": "+9:00",
  "Pacific/Pitcairn": "-8:00",
  "Pacific/Pohnpei": "+11:00",
  "Pacific/Ponape": "+11:00",
  "Pacific/Port_Moresby": "+10:00",
  "Pacific/Rarotonga": "-10:00",
  "Pacific/Saipan": "+10:00",
  "Pacific/Samoa": "-11:00",
  "Pacific/Tahiti": "-10:00",
  "Pacific/Tarawa": "+12:00",
  "Pacific/Tongatapu": "+13:00",
  "Pacific/Truk": "+10:00",
  "Pacific/Wake": "+12:00",
  "Pacific/Wallis": "+12:00",
  "Pacific/Yap": "+10:00",
  "Poland": "+1:00",
  "Portugal": "0:00",
  "ROK": "+9:00",
  "Singapore": "+8:00",
  "SystemV/AST4": "-4:00",
  "SystemV/AST4ADT": "-4:00",
  "SystemV/CST6": "-6:00",
  "SystemV/CST6CDT": "-6:00",
  "SystemV/EST5": "-5:00",
  "SystemV/EST5EDT": "-5:00",
  "SystemV/HST10": "-10:00",
  "SystemV/MST7": "-7:00",
  "SystemV/MST7MDT": "-7:00",
  "SystemV/PST8": "-8:00",
  "SystemV/PST8PDT": "-8:00",
  "SystemV/YST9": "-9:00",
  "SystemV/YST9YDT": "-9:00",
  "Turkey": "+2:00",
  "UCT": "0:00",
  "US/Alaska": "-9:00",
  "US/Aleutian": "-10:00",
  "US/Arizona": "-7:00",
  "US/Central": "-6:00",
  "US/East-Indiana": "-5:00",
  "US/Eastern": "-5:00",
  "US/Hawaii": "-10:00",
  "US/Indiana-Starke": "-6:00",
  "US/Michigan": "-5:00",
  "US/Mountain": "-7:00",
  "US/Pacific": "-8:00",
  "US/Pacific-New": "-8:00",
  "US/Samoa": "-11:00",
  "UTC": "0:00",
  "Universal": "0:00",
  "W-SU": "+3:00",
  "WET": "0:00",
  "Zulu": "0:00",
  "EST": "-5:00",
  "HST": "-10:00",
  "MST": "-7:00",
  "ACT": "+9:30",
  "AET": "+10:00",
  "AGT": "-3:00",
  "ART": "+2:00",
  "AST": "-9:00",
  "BET": "-3:00",
  "BST": "+6:00",
  "CAT": "+2:00",
  "CNT": "-3:30",
  "CST": "-6:00",
  "CTT": "+8:00",
  "EAT": "+3:00",
  "ECT": "+1:00",
  "IET": "-5:00",
  "IST": "+5:30",
  "JST": "+9:00",
  "MIT": "+13:00",
  "NET": "+4:00",
  "NST": "+12:00",
  "PLT": "+5:00",
  "PNT": "-7:00",
  "PRT": "-4:00",
  "PST": "-8:00",
  "SST": "+11:00",
  "VST": "+7:00",
  "(GMT0:00)": "+00:00",
  "(GMT+3:00)": "+03:00",
  "(GMT+1:00)": "+01:00",
  "(GMT+2:00)": "+02:00",
  "(GMT-10:00)": "-10:00",
  "(GMT-9:00)": "-09:00",
  "(GMT-4:00)": "-04:00",
  "(GMT-3:00)": "-03:00",
  "(GMT-5:00)": "-05:00",
  "(GMT-6:00)": "-06:00",
  "(GMT-7:00)": "-07:00",
  "(GMT-8:00)": "-08:00",
  "(GMT-2:00)": "-02:00",
  "(GMT-1:00)": "-01:00",
  "(GMT-3:30)": "-03:30",
  "(GMT+8:00)": "+08:00",
  "(GMT+7:00)": "+07:00",
  "(GMT+10:00)": "+10:00",
  "(GMT+11:00)": "+11:00",
  "(GMT+5:00)": "+05:00",
  "(GMT+12:00)": "+12:00",
  "(GMT+6:00)": "+06:00",
  "(GMT+4:00)": "+04:00",
  "(GMT+5:30)": "+05:30",
  "(GMT+9:00)": "+09:00",
  "(GMT+4:30)": "+04:30",
  "(GMT+5:45)": "+05:45",
  "(GMT+8:30)": "+08:30",
  "(GMT+6:30)": "+06:30",
  "(GMT+3:30)": "+03:30",
  "(GMT+9:30)": "+09:30",
  "(GMT+8:45)": "+08:45",
  "(GMT+10:30)": "+10:30",
  "(GMT-11:00)": "-11:00",
  "(GMT-12:00)": "-12:00",
  "(GMT+13:00)": "+13:00",
  "(GMT+14:00)": "+14:00",
  "(GMT+12:45)": "+12:45",
  "(GMT-9:30)": "-09:30",
}
